<template>
    <div class="counter-offer-container">
        <div v-if="counterOfferData && step === 'offerMake'" :class="{ 'px-3': width < 1000 }">
            <p class="counter-offer-title">Make an Offer</p>
            <div class="offer-container">
                <div class="offer-content">
                    <p class="offer-vibe">
                        <a
                            :href="'/venues/' + this.offerInfo.venue_slug"
                            target="_blank"
                            class="redirect-to-venue"
                            >{{ counterOfferData.venue_name }}</a
                        >
                        is looking for a vibe that’s
                        <span v-if="vibeArray.length < 2" class="vibe-pushed">
                            {{ counterOfferData.vibe }}</span
                        >
                        <span v-else>
                            <span v-for="(vibe, index) in vibeArray.slice(0, -1)" :key="index">
                                <span class="vibe-pushed"> {{ `${vibe}, ` }}</span>
                            </span>
                            <span class="offer-vibe-splitter"> and </span>
                            <span class="vibe-pushed">
                                {{ vibeArray.at(-1) }}
                            </span>
                        </span>
                    </p>
                    <div
                        v-if="counterOfferData.opportunity_detail"
                        class="opp-details-wrapper"
                    >
                        <p class="opp-details-text">Opportunity Details</p>
                        <p class="offer-budget opp-details">
                            {{ counterOfferData.opportunity_detail }}
                        </p>
                    </div>
                    <p v-if="updateOffer" class="offer-budget d-flex align-items-center gap-1">
                        You Get:
                        <span class="align-self-end">
                            ${{ artistGets(offerInfo.propose.payout) }}
                        </span>
                    </p>
                    <div v-else class="d-flex flex-column">
                        <p class="offer-budget d-flex align-items-center gap-1">
                            {{
                                `Accepting Offers ${
                                    !!parseFloat(counterOfferData.budget_without_commission)
                                        ? 'Up To'
                                        : ''
                                }`
                            }}
                            <span
                                v-if="!!parseFloat(counterOfferData.budget_without_commission)"
                                class="align-self-end"
                            >
                                ${{ counterOfferData.budget_without_commission }}
                            </span>
                        </p>
                        <p
                            v-if="!!parseFloat(counterOfferData.budget_without_commission)"
                            class="fine-print"
                        >
                            *Amount does not include Hedlyner commission
                        </p>
                    </div>
                </div>
                <hr style="height: 2px; color: #8b8b8b; margin: 40px 0" />
                <div class="make-offer">
                    <p class="counter-offer-title">Your Offer</p>
                    <div
                        :class="{
                            'd-flex': width > 1000,
                            'mobile-container': width < 1000
                        }"
                    >
                        <div class="d-flex position-relative">
                            <div class="proposed-payout me-3">
                                <p class="proposed-title">Proposed Payout*</p>
                                <input
                                    placeholder="Eg. $100"
                                    @input="formattedPayout"
                                    v-model="proposedPayout"
                                />
                                <p v-if="proposedPayoutError" class="error-text">
                                    {{ proposedPayoutError }}
                                </p>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="proposed-payout me-3">
                                <p class="proposed-title">Set Start Time*</p>
                                <div class="start-time-field">
                                    <div
                                        @click="timeSelector.handleShowStartTime"
                                        @keydown.enter="timeSelector.handleShowStartTime"
                                        @keydown.space="timeSelector.handleShowStartTime"
                                        class="time-field"
                                        tabindex="0"
                                    >
                                        <p class="event-time">{{ availability }}</p>
                                        <img
                                            :src="getIcon() + 'timepicker-icon.png'"
                                            :class="{
                                                'rotate-arrow':
                                                    timeSelector.showStartTime.value
                                            }"
                                        />
                                    </div>
                                    <div
                                        v-if="timeSelector.showStartTime.value"
                                        class="select-time"
                                    >
                                        <div class="time-format-container">
                                            <p
                                                class="time-format"
                                                :class="{
                                                    'selected-time-format':
                                                        timeSelector.selectTimeFormat.value
                                                }"
                                                @click="timeSelector.changeTimeFormat"
                                            >
                                                AM
                                            </p>
                                            <p
                                                class="time-format"
                                                :class="{
                                                    'selected-time-format':
                                                        !timeSelector.selectTimeFormat.value
                                                }"
                                                @click="timeSelector.changeTimeFormat"
                                            >
                                                PM
                                            </p>
                                        </div>
                                        <div class="divider"></div>
                                        <div class="time-count">
                                            <p
                                                @click="timeSelector.setTime(time)"
                                                class="time"
                                                v-for="(time, index) in timeSelector.timeList
                                                    .value"
                                                :key="index"
                                            >
                                                {{ time }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="proposed-payout me-3">
                            <p class="proposed-title">Set Duration*</p>

                            <span class="set-duration-input">
                                <input
                                    placeholder="10 mins"
                                    v-model="proposedSetLength"
                                    @input="numericInput"
                                    :class="{
                                        'border-error': proposedSetLengthError.length
                                    }"
                                    class="duration-value"
                                    type="text"
                                    maxlength="5"
                                />
                                <span v-if="proposedSetLength">{{
                                    `${proposedSetLength > 1 ? 'mins' : 'min'}`
                                }}</span>
                            </span>
                            <p v-if="proposedSetLengthError" class="error-text">
                                {{ proposedSetLengthError }}
                            </p>
                        </div>
                    </div>
                    <div class="proposed-payout" :class="{ 'w-100': width < 1000 }">
                        <p class="proposed-title">Message</p>
                        <textarea
                            class="offer-message"
                            placeholder="Hedlyner is a community,  we encourage you to communicate with potential venues…"
                            v-model="proposedMessage"
                        ></textarea>
                        <p v-if="proposedMessageError" class="error-text">
                            {{ proposedMessageError }}
                        </p>
                    </div>
                    <div class="d-flex mt-5 btn-wrapper">
                        <button
                            class="back-to-booking"
                            :class="{ 'disabled-class': !getButtonActive }"
                            @click="makeOffer"
                            :disabled="!getButtonActive"
                        >
                            {{ updateOffer ? 'Update Offer' : 'Make Offer' }}
                        </button>
                        <button
                            class="cancel-btn"
                            @click="clearFields"
                            :class="{ 'disabled-clear-class': !getButtonActive }"
                        >
                            Clear
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="counterOfferData && step === 'offerMade'" :class="{ 'px-3': width < 1000 }">
            <p class="counter-offer-title">
                Offer {{ updateOffer ? 'Updated' : 'Sent' }}, Awaiting Reply
            </p>
            <div class="offer-container">
                <p class="offer-date">Sent {{ offerCreatedAt }}</p>
                <div class="payout-wrapper">
                    <p class="hours-budget">
                        You Get: ${{ artistGets(offerInfo.propose.payout) }}
                    </p>
                    <p class="fee-information">
                        {{ feeInformation(offerInfo.propose.payout) }}
                    </p>
                </div>
                <p class="available-time">
                    Set Start Time: {{ offerInfo.propose.start_avail }} Set Duration:
                    {{ Math.ceil(offerInfo.propose.duration * 60) }} min
                </p>
                <div v-if="offerInfo.propose.message" class="artist-message">
                    <img
                        class="artist-avatar"
                        :src="offerInfo.artist_info.avatar"
                        alt="artist-avatar"
                    />
                    <div class="message-content">
                        <p class="offer-message-render">"{{ offerInfo.propose.message }}"</p>
                        <p>— {{ offerInfo.artist_info.band_name }}</p>
                    </div>
                </div>
                <button @click="editOfferDetails" class="edit-offer-btn">Edit Offer</button>
            </div>
        </div>
        <div
            v-if="counterOfferData && step === 'counterReceived'"
            :class="{ 'px-3': width < 1000 }"
        >
            <p class="counter-offer-title">Counter Offer Received</p>
            <div class="offer-container">
                <p class="offer-date">Venue’s Counter Offer</p>
                <div class="payout-wrapper">
                    <p class="hours-budget">
                        You Get: ${{ artistGets(counterOfferReceived.propose.payout) }}
                    </p>
                    <p class="fee-information">
                        {{ feeInformation(counterOfferReceived.propose.payout) }}
                    </p>
                </div>
                <div v-if="counterOfferReceived.propose.message" class="artist-message">
                    <a
                        :href="'/venues/' + counterOfferReceived.venue_info.slug"
                        target="_blank"
                    >
                        <img
                            :src="counterOfferReceived.venue_info.avatar"
                            class="user-image"
                        />
                    </a>
                    <div class="message-content">
                        <p class="offer-message-render">
                            "{{ counterOfferReceived.propose.message }}"
                        </p>
                        <p>— {{ counterOfferReceived.venue_info.venue_name }}</p>
                    </div>
                </div>
                <div v-if="counterOfferFields">
                    <div class="d-flex input-wrapper">
                        <div class="proposed-payout me-3">
                            <p class="proposed-title">Proposed Payout*</p>
                            <input
                                placeholder="Eg. $100"
                                @input="formattedPayout"
                                v-model="proposedPayout"
                            />
                            <p v-if="proposedPayoutError" class="error-text">
                                {{ proposedPayoutError }}
                            </p>
                        </div>
                        <div class="d-flex">
                            <div class="proposed-payout me-3">
                                <p class="proposed-title">Set Start Time*</p>
                                <div class="start-time-field">
                                    <div
                                        @click="timeSelector.handleShowStartTime"
                                        class="time-field"
                                    >
                                        <p class="event-time">{{ availability }}</p>
                                        <img
                                            :src="getIcon() + 'timepicker-icon.png'"
                                            :class="{
                                                'rotate-arrow':
                                                    timeSelector.showStartTime.value
                                            }"
                                        />
                                    </div>
                                    <div
                                        v-if="timeSelector.showStartTime.value"
                                        class="select-time"
                                    >
                                        <div class="time-format-container">
                                            <p
                                                class="time-format"
                                                :class="{
                                                    'selected-time-format':
                                                        timeSelector.selectTimeFormat.value
                                                }"
                                                @click="timeSelector.changeTimeFormat"
                                            >
                                                AM
                                            </p>
                                            <p
                                                class="time-format"
                                                :class="{
                                                    'selected-time-format':
                                                        !timeSelector.selectTimeFormat.value
                                                }"
                                                @click="timeSelector.changeTimeFormat"
                                            >
                                                PM
                                            </p>
                                        </div>
                                        <div class="divider"></div>
                                        <div class="time-count">
                                            <p
                                                @click="timeSelector.setTime(time)"
                                                class="time"
                                                v-for="(time, index) in timeSelector.timeList
                                                    .value"
                                                :key="index"
                                            >
                                                {{ time }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="proposed-payout me-3 position-relative">
                                <p class="proposed-title">Set Duration*</p>
                                <input
                                    placeholder="10 mins"
                                    v-model="proposedSetLength"
                                    type="text"
                                    maxlength="5"
                                    @input="numericInput"
                                    :class="{
                                        'border-error': proposedSetLengthError
                                    }"
                                />
                                <p class="duration-hours" v-if="!proposedSetLengthError">
                                    {{ getDurationHours }}
                                </p>
                                <p v-if="proposedSetLengthError" class="error-text">
                                    {{ proposedSetLengthError }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="proposed-payout w-100">
                        <p class="proposed-title">Message</p>
                        <textarea
                            class="offer-message"
                            placeholder="Hedlyner is a community,  we encourage you to communicate with potential venues…"
                            v-model="proposedMessage"
                        ></textarea>
                        <p v-if="proposedMessageError" class="error-text">
                            {{ proposedMessageError }}
                        </p>
                    </div>
                    <div class="d-flex mt-5 btn-wrapper">
                        <button
                            :disabled="!getButtonActive"
                            @click="counterOffer"
                            :class="{ 'disabled-class': !getButtonActive }"
                            class="back-to-booking"
                        >
                            Submit Counter Offer
                        </button>
                        <button
                            @click="counterOfferFields = !counterOfferFields"
                            :class="{ 'disabled-clear-class': !getButtonActive }"
                            class="cancel-btn"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
                <div v-if="!counterOfferFields" class="btn-container">
                    <div
                        v-if="counterOfferData.counter_offer_status !== 4"
                        :class="{ 'mobile-btn': width < 1000 }"
                    >
                        <button class="accept-btn" @click="acceptOffer">Accept</button>
                        <button
                            class="other-action-btn"
                            @click="counterOfferFields = !counterOfferFields"
                        >
                            Counter
                        </button>
                        <button class="other-action-btn" @click="goToChat">Message</button>
                    </div>
                    <button
                        :style="{ flex: !counterOfferFields ? '0 0 0%' : '0 0 30%' }"
                        class="other-action-btn"
                        v-b-modal.modal-decline
                    >
                        Decline
                    </button>
                    <b-modal
                        no-enforce-focus
                        centered
                        id="modal-decline"
                        content-class="modal-decline"
                    >
                        <template #modal-header>
                            <div class="modal-wrapper">
                                <p class="title-modal">You are about to decline this offer</p>
                                <p class="warning-msg">
                                    Are you sure you want to turn this down?
                                </p>
                                <button @click="declineOffer">Decline Offer</button>
                            </div>
                        </template>
                        <template #modal-footer>
                            <div class="w-100 d-flex flex-column align-items-center">
                                <p
                                    @click="$bvModal.hide('modal-decline')"
                                    class="close-decline-modal"
                                >
                                    Exit without declining
                                </p>
                            </div>
                        </template>
                    </b-modal>
                </div>
                <hr style="height: 2px; color: #8b8b8b; margin: 40px 0 20px 0" />
                <div class="original-offer-title">
                    <p>Original Offer</p>
                    <p>Sent {{ offerCreatedAt }}</p>
                </div>
                <div class="payout-wrapper">
                    <p class="hours-budget-original">
                        You Get: ${{ artistGets(counterOfferReceived.previous_offer.payout) }}
                    </p>
                    <p class="fee-information">
                        {{ feeInformation(counterOfferReceived.previous_offer.payout) }}
                    </p>
                </div>
                <p class="available-time-original">
                    Available {{ counterOfferReceived.previous_offer.start_avail }} –
                    {{
                        timeSelector
                            .calculateEndTime(counterOfferReceived.previous_offer.duration)
                            .join(' ')
                    }}
                </p>
                <div v-if="counterOfferReceived.previous_offer.message" class="artist-message">
                    <div class="message-content-original">
                        <p class="offer-message-render">
                            "{{ counterOfferReceived.previous_offer.message }}"
                        </p>
                        <p>— {{ offerInfo.artist_info.band_name }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '@/helpers/notification'
    import useTimeSelector from '@/composables/useTimeSelector.js'
    import checkScreen from '../../../../mixins/check-screen'
    export default {
        name: 'CounterOffer',
        mixins: [checkScreen],
        props: {
            counterOfferData: {
                type: Object
            },
            eventIdInvite: {
                type: Number
            },
            artistId: {
                type: Number
            }
        },
        data: () => ({
            proposedPayout: '',
            proposedSetLength: '',
            offerInfo: {},
            proposedMessage: '',
            step: 'offerMake',
            eventId: '',
            bidArtist: '',
            counterOfferReceived: {},
            counterOfferFields: false,
            proposedPayoutError: '',
            proposedSetLengthError: '',
            proposedMessageError: '',
            respBidArtistId: '',
            formattedTime: '',
            formattedTimeEnd: '',
            updateOffer: false
        }),
        computed: {
            hedlynerCommission(self) {
                return (fee) => {
                    return fee
                        ? parseFloat(
                              fee * self.offerInfo.artist_info.artist_commission
                          ).toFixed(2)
                        : 0
                }
            },
            artistGets(self) {
                return (fee) => {
                    return fee
                        ? parseFloat(fee - self.hedlynerCommission(fee)).toFixed(2)
                        : 'N/A'
                }
            },
            artistResponded() {
                return !!this.offerInfo.respondedArtists.find(
                    (ba) => ba.artist_id === this.offerInfo.artist_info.artist_id
                )
            },
            feeInformation(self) {
                return (payout) => {
                    const hedlynerFee = self.hedlynerCommission(payout)

                    return `Artist Fee: $${payout}, Hedlyner Commission: $${hedlynerFee}`
                }
            },
            offerCreatedAt() {
                const createdAt = this.offerInfo.propose.created_at.split(' ')
                const month = createdAt[1]
                const date = createdAt[2]
                const year = createdAt[3]

                return `${month} ${date} ${year}`
            },
            vibeArray() {
                return this.counterOfferData.vibe.split(',')
            },
            getButtonActive() {
                return !!(
                    (this.proposedPayout &&
                        this.proposedSetLength &&
                        this.proposedSetLength >= 10) ||
                    this.proposedSetLength <= 300
                )
            },
            getDurationHours() {
                if (!this.proposedSetLength.length) return ''
                return parseFloat(this.proposedSetLength) > 1 ? 'mins' : 'min'
            },
            getPreviousDuration() {
                if (!this.counterOfferReceived.previous_offer.duration) return ''
                return this.counterOfferReceived.previous_offer.duration > 1 ? 'hrs' : 'hr'
            },

            getCounterDuration() {
                if (!this.counterOfferReceived.propose.duration) return ''
                return this.counterOfferReceived.propose.duration > 1 ? 'hrs' : 'hr'
            },
            getBudget() {
                return this.counterOfferData.min || this.counterOfferData.max
                    ? this.counterOfferData.min + '-' + this.counterOfferData.max
                    : this.counterOfferData.budget
            },
            availability() {
                return `${this.timeSelector.startTime.value} ${this.timeSelector.timeFormat.value}`
            },
            endingAvailability() {
                return `${this.timeSelector.endTime.value} ${this.timeSelector.timeFormatEnd.value}`
            }
        },
        watch: {
            proposedSetLength: function (duration) {
                if (parseInt(duration) < 10) {
                    this.proposedSetLengthError =
                        'The set length should be more than 10 minutes'
                }
                if (parseInt(duration) > 300) {
                    this.proposedSetLengthError = 'The set length should be more than 5 hours'
                }
                this.proposedSetLengthError = ''
            },
            counterOfferReceived: {
                handler: function (counterOffer) {
                    if (this.step === 'counterReceived' && !this.counterOfferFields) {
                        const startTime = counterOffer.previous_offer.start_avail.split(' ')
                        const time = startTime[0]
                        const format = startTime[1]

                        this.timeSelector.startTime.value = time
                        this.timeSelector.timeFormat.value = format
                    }
                },
                immediate: true
            }
        },
        methods: {
            editOfferDetails() {
                const startTime = this.offerInfo.propose.start_avail.split(' ')
                const time = startTime[0]
                const format = startTime[1]

                this.timeSelector.timeFormat.value = format
                this.proposedPayout = '$' + this.offerInfo.propose.payout
                this.timeSelector.setTime(time)
                this.proposedSetLength = Math.ceil(
                    parseFloat(this.offerInfo.propose.duration * 60).toFixed(0)
                )
                this.proposedMessage = this.offerInfo.propose.message
                this.updateOffer = true
                this.step = 'offerMake'
            },
            goToChat() {
                sessionStorage.setItem('recipient_id', this.offerInfo.venue_user_id)
                window.open('/profile/mail-chat', '_blank')
            },
            numericInput() {
                this.proposedSetLength = this.proposedSetLength.replace(/[^0-9.,]/g, '')
            },
            redirectToVenuePage() {
                window.location.href = '/venues/' + this.offerInfo.venue_slug
            },
            getIcon() {
                return '/images/'
            },
            formattedPayout() {
                if (this.proposedPayout === '' || isNaN(this.proposedPayout)) {
                    return ''
                }
                return (this.proposedPayout = '$' + this.proposedPayout)
            },
            updateTimeAvailability() {
                const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9] [APap][Mm]$/
                if (regex.test(this.availability)) {
                    this.formattedTime = ''
                } else {
                    this.formattedTime = 'Enter the time in the format 00:00 AM/PM'
                }
            },
            updateTimeEndingAvailability() {
                const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9] [APap][Mm]$/
                if (regex.test(this.endingAvailability)) {
                    this.formattedTimeEnd = ''
                } else {
                    this.formattedTimeEnd = 'Enter the time in the format 00:00 AM/PM'
                }
            },
            clearFields() {
                this.proposedPayout = ''
                this.proposedSetLength = ''
                this.availability = ''
                this.endingAvailability = ''
                this.proposedMessage = ''
            },
            async makeOffer() {
                try {
                    const setLength = parseFloat(
                        parseInt(this.proposedSetLength) / 60
                    ).toFixed(2)

                    if (this.proposedPayout && this.availability && this.proposedSetLength) {
                        const eventId = this.eventId
                        const response = await axios.post('/api/event/apply/' + eventId, {
                            counter_offer: this.proposedPayout,
                            counter_offer_duration: setLength,
                            start_avail: this.formattedTime
                                ? 'Enter correct format'
                                : this.availability,
                            extra_requirements: this.proposedMessage,
                            artist_id: this.artistId
                        })
                        notification('success', response.data.message)
                        await this.getArtistOffer()
                        this.step = 'offerMade'
                        this.respBidArtistId = response.data.bid_artist.id
                    } else {
                        if (!this.endingAvailability)
                            this.formattedTime = 'Enter the time in the format 00:00 AM/PM'
                        if (!this.availability)
                            this.formattedTimeEnd = 'Enter the time in the format 00:00 AM/PM'
                    }
                } catch (error) {
                    notification('error', error)
                }
            },
            async getArtistOffer() {
                const eventId = this.eventId
                const result = await axios.get(`/venue-offer/${eventId}/${this.artistId}`)
                this.offerInfo = result.data.data
                if (
                    this.offerInfo.response.counter_offer_status === 2 &&
                    this.offerInfo.is_received &&
                    this.artistResponded
                ) {
                    this.step = 'counterReceived'
                } else {
                    if (
                        this.offerInfo.propose.counter_offer_status === 5 &&
                        !this.offerInfo.is_received
                    ) {
                        this.step = 'offerMade'
                    } else {
                        this.step = 'offerMake'
                    }
                }
            },
            async acceptOffer() {
                try {
                    const response = await axios.get(
                        '/venue-offer/' + this.bidArtist + '/accept'
                    )
                    this.proposedPayout = ''
                    this.proposedSetLength = ''
                    this.availability = ''
                    this.endingAvailability = ''
                    this.proposedMessage = ''
                    notification('success', response.data.message)
                    window.location.reload()
                } catch (error) {
                    notification('error', error.response.data.message)
                }
            },
            async counterOffer() {
                try {
                    const setLength = parseFloat(
                        parseInt(this.proposedSetLength) / 60
                    ).toFixed(2)

                    const response = await axios.put(
                        '/venue-offer/' + this.bidArtist + '/counter',
                        {
                            venue_id:
                                this.counterOfferData.venue_id ??
                                this.counterOfferReceived?.venue_id,
                            artist_id: this.artistId,
                            counter_offer_propose: this.proposedPayout,
                            counter_offer_duration: setLength,
                            counter_offer_message: this.proposedMessage,
                            end_avail: this.formattedTimeEnd
                                ? 'Enter correct format'
                                : this.endingAvailability,
                            start_avail: this.formattedTime
                                ? 'Enter correct format'
                                : this.availability
                        }
                    )
                    await this.getArtistOffer()
                    notification('success', response.data.message)
                } catch (error) {
                    if (error.response.data.errors.counter_offer_propose)
                        this.proposedPayoutError =
                            error.response.data.errors.counter_offer_propose[0]
                    if (error.response.data.errors.counter_offer_duration)
                        this.proposedSetLengthError =
                            error.response.data.errors.counter_offer_duration[0]
                    if (error.response.data.errors.counter_offer_message)
                        this.proposedMessageError =
                            error.response.data.errors.counter_offer_message[0]
                    notification('error', error.response.data.message)
                }
            },
            async declineOffer() {
                try {
                    const response = await axios.get(
                        'venue-offer/' + this.bidArtist + '/decline'
                    )
                    notification('success', response.data.message)
                    window.location.href = '/booking-manager/artist'
                } catch (error) {
                    notification('error', error.response.data.message)
                }
            },
            async getCounterOfferReceived() {
                try {
                    const result = await axios.get(
                        '/venue-offer/' + this.bidArtist + '/received'
                    )
                    this.counterOfferReceived = result.data.data
                } catch {
                    this.counterOfferReceived = {}
                }
            }
        },
        setup() {
            const {
                timeList,
                timeListEnd,
                startTime,
                endTime,
                timeFormat,
                timeFormatEnd,
                showStartTime,
                showEndTime,
                selectTimeFormat,
                selectTimeFormatEnd,
                resetSetTimeAndDuration,
                calculateDuration,
                calculateEndTime,
                changeTimeFormat,
                changeEndTimeFormat,
                setTime,
                setEndTime,
                handleShowStartTime,
                handleShowEndTime
            } = useTimeSelector()

            return {
                timeSelector: {
                    timeList,
                    timeListEnd,
                    startTime,
                    endTime,
                    timeFormat,
                    timeFormatEnd,
                    showStartTime,
                    showEndTime,
                    selectTimeFormat,
                    selectTimeFormatEnd,
                    resetSetTimeAndDuration,
                    calculateDuration,
                    calculateEndTime,
                    changeTimeFormat,
                    changeEndTimeFormat,
                    setTime,
                    setEndTime,
                    handleShowStartTime,
                    handleShowEndTime
                }
            }
        },
        async created() {
            this.eventId = localStorage.getItem('eventId')
            this.bidArtist = localStorage.getItem('bidArtist')
            await this.getArtistOffer()
            if (this.step === 'counterReceived') await this.getCounterOfferReceived()
        },
        beforeDestroy() {
            localStorage.removeItem('bidArtist')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .modal-decline {
        padding: 50px 50px 0 50px;
        background: #161616;
        border-radius: 20px;
    }
    .set-duration-input {
        color: #dedede;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        padding: 12px 20px 15px 20px;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        max-width: 210px;
        max-height: 52px;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .duration-value {
        position: relative;
        color: #dedede;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        border: none;
        background: none;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        border: 0 !important;
        padding-left: 5px;
    }
    .duration-value:focus {
        outline: none;
        border: none;
        box-shadow: none;
    }
    .offer-message-render {
        white-space: pre-line;
    }
    .offer-message {
        min-height: 141px;
        max-width: 670px;
        width: 100%;
        padding: 12px 16px 16px 16px;
        border-radius: 12px;
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        background: inherit;
    }
    .offer-message::placeholder {
        color: #646464;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .btn-wrapper {
        max-width: 670px;
        width: 100%;
    }
    .disabled-class {
        background: #464646 !important;
        border: none !important;
    }
    .disabled-clear-class {
        border-color: #464646 !important;
        color: #8b8b8b !important;
    }
    .border-error {
        border: 1px solid #d52020 !important;
    }
    .duration-hours {
        color: #dedede;
        position: absolute;
        right: 10%;
        top: 48%;
    }
    .modal-wrapper {
        display: flex;
        flex-direction: column;
        gap: 40px;
    }
    .modal-wrapper button {
        color: #1b0d29;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 1.8px;
        text-transform: uppercase;
        padding: 20px;
        border-radius: 100px;
        background: #d7eb5a;
        border: 0;
    }
    .vibe-pushed {
        color: #c9cd00;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
        text-transform: capitalize;
    }
    .warning-msg {
        color: #ffffff;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.7px;
    }
    .title-modal {
        color: #ffffff;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 21px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0.63px;
        text-transform: uppercase;
    }
    .close-decline-modal {
        display: flex;
        min-width: 308px;
        min-height: 38px;
        flex-direction: column;
        justify-content: center;
        color: #ffffff;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 1.25px;
        text-transform: uppercase;
        cursor: pointer;
    }
    .error-text {
        color: #d52020 !important;
        margin-top: 5px;
        max-width: 190px;
    }
    .redirect-to-venue {
        cursor: pointer;
        text-decoration: none;
        color: #acacac;
    }
    .artist-avatar {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        align-self: flex-start;
    }
    .edit-offer-btn {
        display: flex;
        max-width: 325.5px;
        width: 100%;
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #c9cd00;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        color: black;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        border: none;
    }
    .message-content-original {
        color: #646464;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 650;
        line-height: 125%;
    }
    .available-time-original {
        color: #646464;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .fee-information {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .payout-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
        gap: 16px;
    }
    .hours-budget-original {
        color: #646464;
        font-family: Instrument Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .original-offer-title {
        display: flex;
        gap: 10px;
    }
    .original-offer-title p {
        color: #646464;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .btn-container {
        display: flex;
        gap: 10px;
        max-width: 60%;
        flex-wrap: wrap;
    }
    .other-action-btn {
        min-height: 45px;
        padding: 7px 20px 10px 20px;
        border-radius: 100px;
        border: 1px solid #c9cd00;
        color: #c9cd00;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        background: transparent;
        flex: 0 1 30%;
    }
    .accept-btn {
        min-height: 45px;
        padding: 7px 20px 10px 20px;
        border-radius: 100px;
        border: 1px solid #c9cd00;
        background: #c9cd00;
        color: #262626;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        flex: 0 1 30%;
    }
    .artist-message {
        display: flex;
        gap: 12px;
        margin: 20px 0;
    }
    .user-image {
        max-width: 40px;
        max-height: 40px;
        border-radius: 20px;
    }
    .message-content {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .available-time {
        color: #c9cd00;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .hours-budget {
        color: #c9cd00;
        font-family: Instrument Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .offer-date {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
        margin-bottom: 40px;
    }
    .cancel-btn {
        padding: 7px 20px 10px 20px;
        border-radius: 100px;
        border: 1px solid #c9cd00;
        color: #c9cd00;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        background: transparent;
        flex: 0 1 50%;
    }
    .back-to-booking {
        border-radius: 100px;
        border: 1px solid #c9cd00;
        background: #c9cd00;
        padding: 7px 30px 10px 30px;
        color: #262626;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        flex: 0 1 24%;
        margin-right: 10px;
        flex: 0 1 50%;
    }
    .make-offer {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 67%;
    }
    .proposed-payout {
        margin-top: 15px;
    }
    .proposed-title {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        margin-bottom: 5px;
        max-width: 180px;
    }
    .proposed-payout input {
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        padding: 12px 15px 15px 15px;
        color: #dedede;
        min-width: 50%;
    }
    .opp-details-wrapper {
        max-width: 660px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        margin-top: 24px;
    }
    .opp-details-text {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .opp-details {
        text-overflow: ellipsis;
        overflow: hidden;
        margin-top: -35px;
    }
    .offer-budget {
        white-space: pre-line;
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .fine-print {
        white-space: pre-line;
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: italic;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .offer-budget span {
        color: #c9cd00;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .counter-offer-container {
        margin-top: 60px;
    }
    .counter-offer-title {
        color: #c9cd00;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .offer-container {
        padding: 20px 20px 32px 25px;
        border-radius: 15px;
        background: #262626;
    }
    .offer-content {
        max-width: 70%;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .offer-vibe {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .offer-vibe-splitter {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
        text-transform: lowercase;
    }

    .divider {
        height: 1px;
        width: 100%;
        background: #8b8b8b;
    }
    .start-time-field,
    .end-time-field {
        position: relative;
    }
    .time-field {
        cursor: pointer;
        display: flex;
        padding: 12px 12px 16px 16px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        min-width: 218px;
        min-height: 52px;
        justify-content: space-between;
        align-items: center;
    }
    .timepicker {
        display: flex;
        align-items: center;
        gap: 25px;
    }
    .time-count::-webkit-scrollbar {
        width: 8px;
    }
    .time-count::-webkit-scrollbar-track {
        background-color: none;
    }
    .time-count::-webkit-scrollbar-thumb {
        max-height: 64px;
        border-radius: 8px;
        background: #8b8b8b;
    }
    .time-count {
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
        gap: 8px;
    }
    .time {
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        cursor: pointer;
        margin: 0;
    }
    .time span {
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .select-time {
        z-index: 1;
        position: absolute;
        padding: 8px 8px 12px 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        border-radius: 12px;
        background: #333;
        box-shadow: 0 6px 12px -4px rgba(0, 0, 0, 0.5);
        top: 50px;
        left: 0;
        max-height: 200px;
        min-width: 150px;
    }
    .rotate-arrow {
        transform: rotate(180deg);
    }
    .select-time::-webkit-scrollbar {
        display: none;
    }
    .time-format-container {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }
    .time-format {
        display: flex;
        padding: 4px 8px;
        justify-content: center;
        align-items: center;
        flex: 1 0 0;
        border-radius: 6px;
        margin: 0;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        color: #8b8b8b;
        cursor: pointer;
    }
    .selected-time-format {
        background: #cdeb09;
        color: #121212;
    }
    .event-time {
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        margin: 0;
    }
    .mobile-container {
        max-width: 330px;
    }
    .mobile-btn {
        display: flex;
        gap: 8px;
    }
    @media (max-width: 1000px) {
        .offer-vibe {
            font-size: 22px;
        }
        .offer-budget {
            font-size: 22px;
        }
        .offer-budget span {
            font-size: 22px;
        }
        .offer-container {
            padding: 20px 16px;
        }
        .back-to-booking {
            font-size: 16px;
        }
        .cancel-btn {
            font-size: 16px;
        }
        .counter-offer-title {
            font-size: 38px;
        }
        .proposed-payout input {
            max-width: 100%;
        }
        .offer-content {
            max-width: 100%;
        }
        .make-offer {
            width: 100%;
        }
        .proposed-payout {
            width: 48%;
        }
        .time-field {
            min-width: 140px;
        }
        .original-offer-title {
            flex-direction: column;
        }
        .accept-btn {
            font-size: 16px;
        }
        .other-action-btn {
            font-size: 16px;
        }
        .original-offer-title p {
            font-size: 22px;
        }
        .btn-container {
            flex-direction: column;
            max-width: 100%;
        }
        .mobile-btn {
            flex-direction: column;
        }
        .input-wrapper {
            flex-direction: column;
        }
    }
</style>
